export const filterLabel = {
  default: '',
  created_at_gteq: 'Data de criação inicial',
  created_at_lteq: 'Data de criação final',
  applicable_start_date_lteq: 'Empenhos presentes no período de',
  applicable_end_date_gteq: 'Até',
  city_id_eq: 'Cidade',
  product_id_eq: 'Produto',
  establishment_company_id_eq: 'Estabelecimento',
  client_company_id_eq: 'Empresa Cliente',
  client_branch_id_eq: 'Filial',
  client_company_branch_id_eq: 'Filial',
  client_equipment_id_eq: 'Equipamento',
  in_effect_until_gteq: 'Data de efetivação inicial',
  in_effect_until_lteq: 'Data de efetivação final',
}
